import React, { Component } from "react";
import { Accessor, GState, ZTime } from "IZOX/STATIC";
import PropsType from "prop-types";
import _ from "lodash";
import { HStack, VStack, XButton, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class MonthCore extends Component {

  static propTypes = {
    disYear: PropsType.number,
    disMonth: PropsType.number,
    _isValidMonth: PropsType.func,
    _onSelectorChange: PropsType.func,
    styles: PropsType.object
  };

  static defaultProps = {
    disYear: ZTime.Now().year(),
    disMonth: ZTime.Now().month(),
    _isValidMonth: null,
    _onSelectorChange: null,
    styles: {}
  };

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(MonthCore.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  onBtnPress = (month) => {
    let {disYear, _onSelectorChange} = this.props;
    _onSelectorChange?.(disYear, month);
  };

  renderMonthBtn(month, key){
    let {disMonth, disYear, _isValidMonth, size, styles} = this.props;
    let str = ZTime.monthDis?.[GState.lang]?.Full?.[month];
    let style = styles.coreMonthBtnText(size);
    let isValid = _isValidMonth?.(disYear, month) ?? false;

    if(disMonth === month){
      style = {
        ...style, 
        ...styles.coreMonthBtnTextInSelect(size)
      };
    }
    if(!isValid){
      style = {
        ...style, 
        ...styles.coreMonthBtnTextDisabled(size)
      };
    }

    return (
      <XButton key={key} padding={0}
        disabled={!isValid}
        onClick={(e) => {
          e.stopPropagation();
          this.onBtnPress(month);
        }} 
        style={styles.coreMonthBtn(size)}>
        <XText style={style}>
          {str}
        </XText>
      </XButton>
    );
  }

  renderMonthBtnList(start, end){
    return (
      <VStack width={"50%"}>
        {_.map(_.range(start, end), (o, i) => {
          return this.renderMonthBtn(o, i);
        })}
      </VStack>
    );
  }

  render(){
    return (
      <HStack>
        {this.renderMonthBtnList(0, 6)}
        {this.renderMonthBtnList(6, 12)}
      </HStack>
    );
  }

}

export default MonthCore;
